// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hold-div {
  width: 100px;
  height: 100px;
  border: 2px solid rgb(255, 255, 255);
  cursor: pointer;
  user-select: none; /* Prevent text selection during hold */
  -webkit-user-select: none; /* For Safari */
  -ms-user-select: none; /* For IE/Edge */
  -moz-user-select: none; /* For Firefox */
  -webkit-tap-highlight-color: transparent; /* Remove tap highlight on mobile */
  background-color: rgb(255, 255, 255);
  transition: background-color 0.3s ease;
}

.hold-div:active {
  background-color: steelblue;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
